module.exports = __webpack_public_path__ + "img/banner.2b0da03.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/honor_system/banner.png
// module id = jltB
// module chunks = 15